// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1vPny","insightsList":"newBusinessInsightsMenu_insightsList__3bsa2","active":"newBusinessInsightsMenu_active__3Fzkl"};